import { Component, Input } from "@angular/core";
import { Sizes, State } from "../types/progress-bar.types";

@Component({
  selector: "ds-progress-bar",
  templateUrl: "./ds-progress-bar.component.html",
  styleUrls: ["./ds-progress-bar.component.scss"],
})
export class DsProgressBarComponent {
  @Input() value: number = 0;
  @Input() max: number = 100;
  @Input() min: number = 0;
  @Input() showLabel: boolean = true;
  @Input() state: State = "default";
  @Input() size: Sizes = "md";

  getPercentage(): number {
    const range = this.max - this.min;
    const percentage = ((this.value - this.min) / range) * 100;
    return Math.round(Math.max(0, Math.min(100, percentage)));
  }
}
